import React from "react";
import { localize } from "redux-i18n";

const SecurityWarning = ({ t }) => (
  <React.Fragment>
    <div className="mb-3 text-color-warning">{t("MI_SHARING_NOTICE")}</div>
    <div className="mb-3">{t("MI_SHARING_NOTICE_PART_ONE")}</div>
    <div>{t("MI_SHARING_NOTICE_PART_TWO")}</div>
  </React.Fragment>
);
export default localize()(SecurityWarning);
